<div
  #sidepanel
  class="col-fixed z-10 flex h-full flex-col overflow-visible border-r border-gray-400 bg-gray-100 p-0 transition-all duration-200"
  [ngClass]="{
    'p-sidepanel-collapsed': !sidebarExpanded() && !sidebarHovered(),
    'p-sidepanel-expanded': sidebarExpanded() || sidebarHovered(),
    'shadow-none': !sidebarExpanded() && !sidebarHovered(),
    'p-sidepanel-shadow': !sidebarExpanded() && sidebarHovered()
  }"
  role="menubar"
  aria-orientation="vertical"
  [attr.aria-label]="'common.sidebar' | translate">
  <div class="flex h-full flex-col">
    <section class="relative flex justify-end px-2">
      <button
        pButton
        type="button"
        class="p-sidepanel-button p-button-sm p-button-outlined p-button-round text-primary-400 absolute z-20 w-8 border-gray-300 shadow"
        [icon]="sidepanelIcon"
        (click)="handleToggleSidebar()"
        [title]="(sidebarExpanded() ? 'common.sidebar.close' : 'common.sidebar.open') | translate"></button>
    </section>
    <div
      class="lean-scrollbar h-full overflow-x-hidden overflow-y-auto p-4 pr-2"
      [ngClass]="{
        'overflow-y-hidden': (!sidebarExpanded() && !sidebarHovered()) || loading,
        'overflow-y-auto': sidebarExpanded() && !loading
      }"
      (mouseenter)="handleHoverSidebar(true)"
      (mouseleave)="handleHoverSidebar(false)">
      <div
        class="relative transition-all duration-200"
        [ngClass]="{
          'p-sidepanel-content-hidden': !sidebarExpanded() && !sidebarHovered(),
          'p-sidepanel-content-visible': sidebarExpanded() || sidebarHovered()
        }">
        <ng-container *ngIf="!loading; else loadingTpl">
          <ng-container *ngIf="sidebarExpanded() || sidebarHovered()" [ngTemplateOutlet]="content"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<p-drawer
  [(visible)]="sidePanelVisible"
  [dismissible]="true"
  [showCloseIcon]="true"
  [closeOnEscape]="true"
  [autoZIndex]="true"
  position="left"
  styleClass="p-drawer-custom z-20 w-full sm:w-[24rem] md:w-[30rem]"
  [autoZIndex]="false"
  (onHide)="sidePanelVisible.set(false)">
  <ng-template pTemplate="content">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </ng-template>
</p-drawer>

<ng-template #loadingTpl>
  <p-skeleton *ngFor="let i of [0, 1, 2, 3]" height="10rem" styleClass="my-2"></p-skeleton>
</ng-template>
